export default {
    // getLayout: state => state.layout
}